// The grain of the page: a layer behind the app that the tiles of `lib/grain.ts`
// mask. The color comes from `--color-grain`, so one set of tiles serves each
// look. The seed is new on each load. It draws from `Math.random`, never from
// the match source, as the carry and the cloud do.

import { GRAIN_CELL_PX, GRAIN_SEED_RANGE, GRAIN_TILE_CELLS } from '../constants';
import { el } from '../lib/dom';
import { grainTileSvg } from '../lib/grain';
import { createRng } from '../lib/rng';

export const createPageGrain = (): HTMLElement => {
  const rng = createRng(Math.floor(Math.random() * GRAIN_SEED_RANGE));
  const tiles = GRAIN_TILE_CELLS.map(
    (sideCells) => `url("data:image/svg+xml,${encodeURIComponent(grainTileSvg(rng, sideCells))}")`,
  );
  const sizes = GRAIN_TILE_CELLS.map((sideCells) => `${sideCells * GRAIN_CELL_PX}px`);
  const grain = el('div', { className: 'page-grain', ariaHidden: 'true' });
  grain.style.setProperty('--grain-tiles', tiles.join(', '));
  grain.style.setProperty('--grain-tile-sizes', sizes.join(', '));
  return grain;
};
